(function () {
  function initSection(root) {
    if (!root || root.dataset.zaoudPerfumeByScentInit === 'true') return;
    root.dataset.zaoudPerfumeByScentInit = 'true';

    var viewport = root.querySelector('.zaoud-perfume-by-scent__viewport');
    var track = root.querySelector('.zaoud-perfume-by-scent__track');
    var prevBtn = root.querySelector('[data-zaoud-pbs-prev]');
    var nextBtn = root.querySelector('[data-zaoud-pbs-next]');
    if (!viewport || !track) return;

    var autoScroll = root.dataset.autoScroll !== 'false';
    var paused = false;
    var offset = 0;
    var lastTs = 0;
    var rafId = 0;
    var resumeTimer = 0;

    var dragging = false;
    var dragMoved = false;
    var pointerId = null;
    var startX = 0;
    var startOffset = 0;
    var lastDragX = 0;
    var dragVelocity = 0;
    var lastDragTs = 0;

    function groupWidth() {
      var group = track.querySelector('.zaoud-perfume-by-scent__group');
      if (!group) return 0;
      return group.offsetWidth || group.scrollWidth || 0;
    }

    function stepSize() {
      var item = track.querySelector('.zaoud-perfume-by-scent__item');
      if (!item) return 180;
      var styles = getComputedStyle(root);
      var gap = parseFloat(styles.getPropertyValue('--zaoud-perfume-by-scent-gap')) || 24;
      return item.offsetWidth + gap;
    }

    function maxOffset() {
      var trackW = track.scrollWidth || track.offsetWidth || 0;
      var viewW = viewport.clientWidth || 0;
      return Math.max(0, trackW - viewW);
    }

    function wrapOffset(value) {
      var half = groupWidth();
      if (half <= 1) return value;
      while (value < 0) value += half;
      while (value >= half) value -= half;
      return value;
    }

    function clampOffset(value) {
      return Math.max(0, Math.min(maxOffset(), value));
    }

    function normalizeOffset(value) {
      return autoScroll ? wrapOffset(value) : clampOffset(value);
    }

    function applyOffset() {
      track.style.transform = 'translate3d(' + -offset.toFixed(2) + 'px, 0, 0)';
    }

    function updateArrowState() {
      if (!prevBtn && !nextBtn) return;

      if (autoScroll) {
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
        return;
      }

      var max = maxOffset();
      if (prevBtn) prevBtn.disabled = offset <= 1 || max <= 0;
      if (nextBtn) nextBtn.disabled = offset >= max - 1 || max <= 0;
    }

    function durationMs() {
      var raw = getComputedStyle(root).getPropertyValue('--zaoud-perfume-by-scent-duration').trim();
      var seconds = parseFloat(raw);
      if (!seconds || seconds < 1) seconds = 30;
      return seconds * 1000;
    }

    function frame(ts) {
      if (!lastTs) lastTs = ts;
      var dt = Math.min(48, ts - lastTs);
      lastTs = ts;

      if (!paused && !dragging) {
        var half = groupWidth();
        if (half > 1) {
          offset += (half / durationMs()) * dt;
          if (offset >= half) offset -= half;
          applyOffset();
        }
      }

      rafId = window.requestAnimationFrame(frame);
    }

    function pause() {
      paused = true;
    }

    function resume() {
      if (!autoScroll) return;
      paused = false;
      lastTs = 0;
    }

    function scheduleResume(delay) {
      if (!autoScroll) return;
      clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(resume, delay || 2500);
    }

    function nudge(direction) {
      var step = stepSize();

      if (autoScroll) {
        pause();
        offset = wrapOffset(offset + direction * step);
        applyOffset();
        scheduleResume(2500);
        return;
      }

      offset = clampOffset(offset + direction * step);
      applyOffset();
      updateArrowState();
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      dragging = true;
      dragMoved = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      lastDragX = event.clientX;
      lastDragTs = event.timeStamp || performance.now();
      startOffset = offset;
      dragVelocity = 0;

      pause();
      clearTimeout(resumeTimer);
      viewport.classList.add('is-dragging');

      if (viewport.setPointerCapture) {
        try {
          viewport.setPointerCapture(pointerId);
        } catch (err) {
          /* ignore */
        }
      }
    }

    function onPointerMove(event) {
      if (!dragging || event.pointerId !== pointerId) return;

      var x = event.clientX;
      var delta = startX - x;
      if (Math.abs(delta) > 6) dragMoved = true;

      var now = event.timeStamp || performance.now();
      var frameDelta = x - lastDragX;
      var dt = Math.max(1, now - lastDragTs);
      dragVelocity = frameDelta / dt;
      lastDragX = x;
      lastDragTs = now;

      offset = normalizeOffset(startOffset + delta);
      applyOffset();

      if (dragMoved && event.cancelable) event.preventDefault();
    }

    function onPointerUp(event) {
      if (!dragging || (pointerId != null && event.pointerId !== pointerId)) return;

      dragging = false;
      pointerId = null;
      viewport.classList.remove('is-dragging');

      /* Light flick: advance a bit in the swipe direction */
      if (dragMoved && Math.abs(dragVelocity) > 0.35) {
        var flick = dragVelocity > 0 ? -stepSize() * 0.35 : stepSize() * 0.35;
        offset = normalizeOffset(offset + flick);
        applyOffset();
      }

      updateArrowState();
      scheduleResume(2800);

      /* Suppress click on links after a real swipe */
      if (dragMoved) {
        var suppressClick = function (clickEvent) {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
          viewport.removeEventListener('click', suppressClick, true);
        };
        viewport.addEventListener('click', suppressClick, true);
        window.setTimeout(function () {
          viewport.removeEventListener('click', suppressClick, true);
        }, 0);
      }

      dragMoved = false;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        nudge(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        nudge(1);
      });
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove, { passive: false });
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('lostpointercapture', onPointerUp);

    track.style.animation = 'none';
    track.style.willChange = 'transform';

    if (autoScroll) {
      viewport.addEventListener('mouseenter', function () {
        if (!dragging) pause();
      });
      viewport.addEventListener('mouseleave', function () {
        if (!dragging) resume();
      });
      viewport.addEventListener('focusin', pause);
      viewport.addEventListener('focusout', function (event) {
        if (!viewport.contains(event.relatedTarget) && !dragging) resume();
      });
      rafId = window.requestAnimationFrame(frame);
    } else {
      offset = 0;
      applyOffset();
      updateArrowState();
      window.addEventListener('resize', updateArrowState);
    }

    root._zaoudPerfumeByScentDestroy = function () {
      window.cancelAnimationFrame(rafId);
      clearTimeout(resumeTimer);
      window.removeEventListener('resize', updateArrowState);
      viewport.removeEventListener('pointerdown', onPointerDown);
      viewport.removeEventListener('pointermove', onPointerMove);
      viewport.removeEventListener('pointerup', onPointerUp);
      viewport.removeEventListener('pointercancel', onPointerUp);
      viewport.removeEventListener('lostpointercapture', onPointerUp);
    };

    updateArrowState();
  }

  function boot() {
    document.querySelectorAll('[data-zaoud-perfume-by-scent]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var root =
      (section && section.matches && section.matches('[data-zaoud-perfume-by-scent]') && section) ||
      (section && section.querySelector && section.querySelector('[data-zaoud-perfume-by-scent]'));
    if (root) {
      if (typeof root._zaoudPerfumeByScentDestroy === 'function') {
        root._zaoudPerfumeByScentDestroy();
      }
      root.dataset.zaoudPerfumeByScentInit = '';
      initSection(root);
    }
  });
})();
